import { useParams } from "react-router-dom";
import { getPostBySlug } from "../lib/sanity/client.js";
import { useQuery } from "@tanstack/react-query";
import { PortableText } from "@portabletext/react";
import { urlFor } from "../lib/sanity/image.js";
import "./BlogPost.css";

// import { useNavigate } from "react-router-dom";

const portableTextComponents = {
  types: {
    image: ({ value }) => {
      return (
        <img
          src={urlFor(value)
            .width(800)
              .height(300)
              .quality(80)
              .auto("format")
            .url()}
          alt={value.alt || "Blog image"}
          style={{
            width: '100%',
            height: "auto",
            borderRadius: '12px',
            marginBottom: '1.5rem'
          }}
        />
      );
    },
  },
  marks: {
    link: ({ children, value }) => (
      <a href={value.href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
  },
};

const BlogPost = () => {
  const { slug } = useParams();
  //   const navigate = useNavigate();

  const {
    data: post,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["post", slug],
    queryFn: () => getPostBySlug(slug),
    enabled: !!slug,
  });

  if (isLoading) return <p className="blog-loading">Loading post...</p>;
  if (error) return <p className="blog-loading">Failed to load post</p>;
  if (!post) return <p className="blog-loading">Post not found</p>;

  return (
    <div className="blog-container">
      <div className="blog-main">
        {/* <button className="back-button" onClick={() => navigate(-1)}>
          Back
        </button> */}
        <h1 className="blog-title">{post.title}</h1>
        {post?.mainImage && (
          <img
            src={urlFor(post.mainImage)
              .width(800)
              .height(300)
              .quality(80)
              .auto("format")
              .url()}
            alt={post.mainImage.alt || post.title}
            className="blog-main-image"
          />
        )}
        <div className="blog-body">
          <PortableText value={post.body} components={portableTextComponents} />
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
